import { api } from "../api";

export interface SyncProjeto704DatabaseResponse {
    status: boolean;
    message: string;
    response?: {
        data?: {
            ip_applied?: boolean;
            deployments_started?: number;
            vm?: {
                ip?: string;
            };
        };
    };
}

export async function syncProjeto704Database(
    customerId: number,
    deploy?: boolean
): Promise<SyncProjeto704DatabaseResponse> {
    const body = deploy === undefined ? {} : { deploy };

    const { data } = await api.post<SyncProjeto704DatabaseResponse>(
        `/customers/${customerId}/projeto704/sync-database`,
        body
    );

    return data;
}
